import { client } from "./client";
import interceptors from "./interceptors";
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSRE(params) {
	return client.get("api/sre/data", {
		params: params,
	});
}

function getSREAll(params) {
	return client.get("api/sre/all", {
		params: params,
	});
}

function exportSRE(params) {
	return client.get("api/sre/export", {
		params: params,
	});
}

function exportSREAll(params) {
	return client.get("api/sre/export-all", {
		params: params,
	});
}

function getDetailSRE(params) {
	return client.get("api/sre/detail", {
		params: params,
	});
}

function createSRE(params) {
	return client.post("api/sre/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function approveSRE(params) {
	return client.post("api/sre/update-status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

export default {
	getSRE,
	getSREAll,
	exportSRE,
	exportSREAll,
	getDetailSRE,
	createSRE,
  approveSRE,
};
